import React from "react";
import { useItemModel } from "../itemModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useItemModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const PageHeaderTitle = <>
    <span style={{ color: "#7F7F7F" }}>{Locale["Basic Data"]} </span>
    <span style={{ color: "#000" }}>/ {Locale["Maintenance Items"]}</span>
</>
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "项目名称",
            placeholder:Locale["Item"],
            fieldName: "name"
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "项目编号",
            placeholder:Locale["Item Code"],
            fieldName: "code"
        },
    ]
    
    return (
        <YhPageHeader
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}